import { useEffect, useState } from "react";

import { InvitesHttpService } from "@/modules/candidate/services/InvitesHttpService";
import { isValidNumericParam } from "@/shared/utils/common.utils";
import { notification } from "antd";
import { AssessmentInviteStatus } from "../scenes/AssessmentInvites/invites.constants";
import { useNavigate } from "react-router-dom";
import { NOT_FOUND_ROUTE } from "@/routing/AppRouter/routes.constants";

export interface IScaleAnalysis {
  rank: number;
  paragraphNumber: number;
  content: string;
}

export function useGetInviteScaleAnalysesHook(
  inviteId: number,
  hasTemplate: boolean,
  inviteStatus?: AssessmentInviteStatus,
) {
  const navigate = useNavigate();
  const [scaleAnalyses, setScaleAnalyses] = useState<IScaleAnalysis[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const handleError = (message?: string) => {
      if (message)
        notification.error({
          message,
        });

      navigate(`/${NOT_FOUND_ROUTE}`);
    };

    const fetchScaleAnalyses = async () => {
      if (!isValidNumericParam(inviteId)) {
        handleError("The assessment invite is not valid.");
      }

      if (!hasTemplate || inviteStatus !== AssessmentInviteStatus.Done) {
        // Mainly to support routing to tabs for "In progress" assessments, for example, the "Audit" tab.
        return;
      }

      try {
        setIsLoading(true);
        const data: IScaleAnalysis[] = await InvitesHttpService.getInviteScaleAnalyses(Number(inviteId));
        setScaleAnalyses(data);
      } catch (e: any) {
        handleError("Error fetching overall analysis.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchScaleAnalyses();
  }, [inviteId, inviteStatus, hasTemplate, navigate]);

  return { scaleAnalyses, isLoading };
}
